<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Well String in Corrective Maintenance
    </div>
    <div>
        <mat-icon mat-dialog-close [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
    </div>
</div>
<hr class="my-0" />

<mat-dialog-content>
    <div class="grid grid-cols-4 gap-4 border rounded p-4 ">
        <div class="flex flex-col">
            <div class="text-primary">Field Name</div>
            <div class="font-medium text-lg">{{ data.fieldLongName }}</div>
        </div>
        <div class="flex flex-col">
            <div class="text-primary">Platform Name</div>
            <div class="font-medium text-lg">{{ data.platformLongName }}</div>
        </div>
        <div class="flex flex-col">
            <div class="text-primary">Well Name</div>
            <div class="font-medium text-lg">{{ data.wellLongName }}</div>
        </div>
        <div class="flex flex-col">
            <div class="text-primary">Well String Name</div>
            <div class="font-medium text-lg">{{ data.stringLongName }}</div>
        </div>
    </div>
    <div>
        <!-- CM GENERAL -->
        <ng-container *ngIf="dtGeneral.length > 0">
            <div class="text-lg font-semibold my-4"><u>General</u></div>
            <div class="overflow-x-auto">
                <div class="grid overflow-x-auto">
                    <!-- Header -->
                    <div class="table-cm-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
                        matSort matSortDisableClear>
                        <div class="border py-8 text-center">
                            No
                        </div>

                        <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                            String Indicator
                        </div>

                        <div [mat-sort-header]="'source'" class="flex border justify-center py-4">
                            Source
                        </div>

                        <div [mat-sort-header]="'submissionYear'" class="flex border justify-center py-4">
                            WPB Submission Year
                        </div>

                        <div [mat-sort-header]="'failureDate'" class="flex border justify-center py-4">
                            Failure Date
                        </div>

                        <div [mat-sort-header]="'failEquipment'" class="flex border justify-center py-4">
                            Failed Equipment
                        </div>

                        <div [mat-sort-header]="'problemReported'" class="flex border justify-center py-4">
                            Reported Problem
                        </div>

                        <div [mat-sort-header]="'riskRanking'" class="flex border justify-center py-4">
                            Risk Ranking
                        </div>

                        <div [mat-sort-header]="'forwardActionPlan'" class="flex border justify-center py-4">
                            Forward Action Plan
                        </div>

                        <div [mat-sort-header]="'detailDesc'" class="flex border justify-center py-4">
                            Description
                        </div>

                        <div [mat-sort-header]="'rectifiedDate'" class="flex border justify-center py-4">
                            Rectified Date
                        </div>

                        <div [mat-sort-header]="'status'" class="flex border justify-center py-4">
                            Status
                        </div>
                    </div>
                    <!-- Rows -->
                    <ng-container *ngIf="dtGeneral.length; else noRecords">
                        <ng-container *ngFor="let row of dtGeneral; let i = index; trackBy: trackByFn;">
                            <div class="table-cm-record-grid  grid items-center border-b p-2"
                                [ngClass]="{'bg-primary-100': i % 2 }">
                                <!-- String Indicator -->
                                <div class="block text-center">
                                    {{ i + 1 }}
                                </div>

                                <!-- String Indicator -->
                                <div class="block text-center">
                                    {{ row.stringIndicatorShortName }}
                                </div>

                                <!-- Source -->
                                <div class="block text-center mx-2">
                                    {{ row.source || '-' }}
                                </div>

                                <!-- WPB Submission Year -->
                                <div class="block text-center">
                                    {{ row.submissionYear || '-' }}
                                </div>

                                <!-- Failure Date -->
                                <div class="block text-center">
                                    {{ handleFormatDate(row.failureDate, false) || '-' }}
                                </div>

                                <!-- Failure Equipment -->
                                <div class="block text-center">
                                    {{ row.failEquipment || '-' }}
                                </div>

                                <!-- Reported Problem -->
                                <div class="block text-center">
                                    {{ row.problemReported || '-' }}
                                </div>

                                <!-- Risk Rangking -->
                                <div class="block text-center">
                                    {{ row.riskRanking || '-' }}
                                </div>

                                <!-- Forward Action Plan -->
                                <div class="block text-center">
                                    {{ row.forwardActionPlan || '-' }}
                                </div>

                                <!-- Description -->
                                <div class="block text-center">
                                    {{ row.detailDesc || '-' }}
                                </div>

                                <!-- Rectified Date -->
                                <div class="block text-center">
                                    {{ handleFormatDate(row.rectifiedDate, false) || '-' }}
                                </div>

                                <!-- Status-->
                                <div class="block text-center mx-2" [ngClass]="{
                                            'idleBadge': row.status == status.OPEN,
                                            'successBadge': row.status == status.APPROVED || row.status == status.CLOSED,
                                            'failedBadge': row.status == status.REJECTED,
                                            'warningBadge': row.status == status.READY
                                      }">
                                    {{ row.status || '-' }}
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <!-- CM BASELINE -->
        <ng-container *ngIf="dtCmBaseline.length > 0">
            <div class="text-lg font-semibold my-4"><u>CM Baseline</u></div>
            <div class="overflow-x-auto">
                <div class="grid overflow-x-auto">
                    <!-- Header -->
                    <div class="table-cm-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
                        matSort matSortDisableClear>
                        <div class="border py-8 text-center">
                            No
                        </div>

                        <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                            String Indicator
                        </div>

                        <div [mat-sort-header]="'source'" class="flex border justify-center py-4">
                            Source
                        </div>

                        <div [mat-sort-header]="'submissionYear'" class="flex border justify-center py-4">
                            WPB Submission Year
                        </div>

                        <div [mat-sort-header]="'failureDate'" class="flex border justify-center py-4">
                            Failure Date
                        </div>

                        <div [mat-sort-header]="'failEquipment'" class="flex border justify-center py-4">
                            Failed Equipment
                        </div>

                        <div [mat-sort-header]="'problemReported'" class="flex border justify-center py-4">
                            Reported Problem
                        </div>

                        <div [mat-sort-header]="'riskRanking'" class="flex border justify-center py-4">
                            Risk Ranking
                        </div>

                        <div [mat-sort-header]="'forwardActionPlan'" class="flex border justify-center py-4">
                            Forward Action Plan
                        </div>

                        <div [mat-sort-header]="'detailDesc'" class="flex border justify-center py-4">
                            Description
                        </div>

                        <div [mat-sort-header]="'rectifiedDate'" class="flex border justify-center py-4">
                            Rectified Date
                        </div>

                        <div [mat-sort-header]="'status'" class="flex border justify-center py-4">
                            Status
                        </div>
                    </div>
                    <!-- Rows -->
                    <ng-container *ngIf="dtCmBaseline.length; else noRecords">
                        <ng-container *ngFor="let row of dtCmBaseline; let i = index; trackBy: trackByFn;">
                            <div class="table-cm-record-grid  grid items-center border-b p-2"
                                [ngClass]="{'bg-primary-100': i % 2 }">
                                <!-- String Indicator -->
                                <div class="block text-center">
                                    {{ row.stringIndicatorShortName }}
                                </div>

                                <!-- Source -->
                                <div class="block text-center mx-2">
                                    {{ row.source || '-' }}
                                </div>

                                <!-- WPB Submission Year -->
                                <div class="block text-center">
                                    {{ row.submissionYear || '-' }}
                                </div>

                                <!-- Failure Date -->
                                <div class="block text-center">
                                    {{ handleFormatDate(row.failureDate, false) || '-' }}
                                </div>

                                <!-- Failure Equipment -->
                                <div class="block text-center">
                                    {{ row.failEquipment || '-' }}
                                </div>

                                <!-- Reported Problem -->
                                <div class="block text-center">
                                    {{ row.problemReported || '-' }}
                                </div>

                                <!-- Risk Rangking -->
                                <div class="block text-center">
                                    {{ row.riskRanking || '-' }}
                                </div>

                                <!-- Forward Action Plan -->
                                <div class="block text-center">
                                    {{ row.forwardActionPlan || '-' }}
                                </div>

                                <!-- Description -->
                                <div class="block text-center">
                                    {{ row.detailDesc || '-' }}
                                </div>

                                <!-- Rectified Date -->
                                <div class="block text-center">
                                    {{ handleFormatDate(row.rectifiedDate, false) || '-' }}
                                </div>

                                <!-- Status-->
                                <div class="block text-center mx-2" [ngClass]="{
                                    'idleBadge': row.status == status.OPEN,
                                    'successBadge': row.status == status.APPROVED || row.status == status.CLOSED,
                                    'failedBadge': row.status == status.REJECTED,
                                    'warningBadge': row.status == status.READY
                              }">
                                    {{ row.status || '-' }}
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <!-- CM EMERGING -->
        <ng-container *ngIf="dtCmEmerging.length > 0">
            <div class="text-lg font-semibold my-4"><u>CM Emerging</u></div>
            <div class="overflow-x-auto">
                <div class="grid overflow-x-auto">
                    <!-- Header -->
                    <div class="table-cm-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
                        matSort matSortDisableClear>
                        <div class="border py-8 text-center">
                            No
                        </div>

                        <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                            String Indicator
                        </div>

                        <div [mat-sort-header]="'source'" class="flex border justify-center py-4">
                            Source
                        </div>

                        <div [mat-sort-header]="'submissionYear'" class="flex border justify-center py-4">
                            WPB Submission Year
                        </div>

                        <div [mat-sort-header]="'failureDate'" class="flex border justify-center py-4">
                            Failure Date
                        </div>

                        <div [mat-sort-header]="'failEquipment'" class="flex border justify-center py-4">
                            Failed Equipment
                        </div>

                        <div [mat-sort-header]="'problemReported'" class="flex border justify-center py-4">
                            Reported Problem
                        </div>

                        <div [mat-sort-header]="'riskRanking'" class="flex border justify-center py-4">
                            Risk Ranking
                        </div>

                        <div [mat-sort-header]="'forwardActionPlan'" class="flex border justify-center py-4">
                            Forward Action Plan
                        </div>

                        <div [mat-sort-header]="'detailDesc'" class="flex border justify-center py-4">
                            Description
                        </div>

                        <div [mat-sort-header]="'rectifiedDate'" class="flex border justify-center py-4">
                            Rectified Date
                        </div>

                        <div [mat-sort-header]="'status'" class="flex border justify-center py-4">
                            Status
                        </div>
                    </div>
                    <!-- Rows -->
                    <ng-container *ngIf="dtCmEmerging.length; else noRecords">
                        <ng-container *ngFor="let row of dtCmEmerging; let i = index; trackBy: trackByFn;">
                            <div class="table-cm-record-grid  grid items-center border-b p-2"
                                [ngClass]="{'bg-primary-100': i % 2 }">
                                <!-- String Indicator -->
                                <div class="block text-center">
                                    {{ i + 1 }}
                                </div>

                                <!-- String Indicator -->
                                <div class="block text-center">
                                    {{ row.stringIndicatorShortName }}
                                </div>

                                <!-- Source -->
                                <div class="block text-center mx-2">
                                    {{ row.source || '-' }}
                                </div>

                                <!-- WPB Submission Year -->
                                <div class="block text-center">
                                    {{ row.submissionYear || '-' }}
                                </div>

                                <!-- Failure Date -->
                                <div class="block text-center">
                                    {{ handleFormatDate(row.failureDate, false) || '-' }}
                                </div>

                                <!-- Failure Equipment -->
                                <div class="block text-center">
                                    {{ row.failEquipment || '-' }}
                                </div>

                                <!-- Reported Problem -->
                                <div class="block text-center">
                                    {{ row.problemReported || '-' }}
                                </div>

                                <!-- Risk Rangking -->
                                <div class="block text-center">
                                    {{ row.riskRanking || '-' }}
                                </div>

                                <!-- Forward Action Plan -->
                                <div class="block text-center">
                                    {{ row.forwardActionPlan || '-' }}
                                </div>

                                <!-- Description -->
                                <div class="block text-center">
                                    {{ row.detailDesc || '-' }}
                                </div>

                                <!-- Rectified Date -->
                                <div class="block text-center">
                                    {{ handleFormatDate(row.rectifiedDate, false) || '-' }}
                                </div>

                                <!-- Status-->
                                <div class="block text-center mx-2" [ngClass]="{
                                    'idleBadge': row.status == status.OPEN,
                                    'successBadge': row.status == status.APPROVED || row.status == status.CLOSED,
                                    'failedBadge': row.status == status.REJECTED,
                                    'warningBadge': row.status == status.READY
                              }">
                                    {{ row.status || '-' }}
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="dtCmEmerging.length == 0 && dtCmBaseline.length == 0 && dtGeneral.length == 0 ">
            <div class="my-4">  Well String information do not contain Corrective Maintenance Records . </div>
        </ng-container>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-1" mat-dialog-close>
        Cancel
    </button>
    <!-- <button class="btn btn-primary mx-1" (click)="update()">Save</button> -->
</mat-dialog-actions>

<ng-template #noRecords>
    <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
        There are no records registered!
    </div>
</ng-template>